module.exports = __webpack_public_path__ + "img/undraw_professor_8lrt.a873ff7c.svg";